// Import model
import { FilterSettingsRequest } from '../models/FilterSettingsRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { SettingsCondition } from '../models/SettingsCondition';
import { SettingsFields } from '../models/SettingsFields';
import { SettingsIndexedFields } from '../models/SettingsIndexedFields';

// Import dependency serializers (for complex types)
import { SettingsConditionSerializer } from './SettingsConditionSerializer';
import { SettingsFieldsSerializer } from './SettingsFieldsSerializer';
import { SettingsIndexedFieldsSerializer } from './SettingsIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for FilterSettingsRequest - handles JSON serialization and deserialization with type validation
 */
export class FilterSettingsRequestSerializer {
  /**
   * Deserializes a JSON string into a FilterSettingsRequest instance
   */
  static deserialize(json: string): FilterSettingsRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a FilterSettingsRequest instance
   */
  static fromObject(obj: any): FilterSettingsRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to FilterSettingsRequest');
    }


    const instance: FilterSettingsRequest = {
      top: obj['top'] as number | undefined,
      skip: obj['skip'] as number | undefined,
      orderBy: obj['orderBy'] as SettingsIndexedFields | undefined,
      reverseOrder: obj['reverseOrder'] as boolean | undefined,
      view: obj['view'] as string | undefined,
      fields: obj['fields'] ? (obj['fields'] as any[]).map((item: any) =>
        item as SettingsFields
      ) : [] as any,
      criteria: obj['criteria'] ? (obj['criteria'] as any[]).map((item: any) =>
        SettingsConditionSerializer.fromObject(item)
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of FilterSettingsRequest instances
   */
  static deserializeArray(json: string): FilterSettingsRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a FilterSettingsRequest instance to a JSON string
   */
  static serialize(instance: FilterSettingsRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a FilterSettingsRequest instance to a plain object
   */
  static toObject(instance: FilterSettingsRequest): any {
    return {
      'top': instance.top,
      'skip': instance.skip,
      'orderBy': instance.orderBy,
      'reverseOrder': instance.reverseOrder,
      'view': instance.view,
      'fields': instance.fields?.map((item: any) =>
        item
      ),
      'criteria': instance.criteria?.map((item: any) =>
        SettingsConditionSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of FilterSettingsRequest instances to a JSON string
   */
  static serializeArray(instances: FilterSettingsRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
